export default {
    data() {
        return { generalDeleting: false }
    },
    methods: {
        /**
         * Helper function for deleting an items such as order types and item types
         * @param {string} title The title to be displayed within the confirmation message
         * @param {string} message The message for the confirmation popup
         * @param {number} id The id for the item being deleted
         * @param {function} successCallback The callback function for the toast notification
         * @param {string} path The endpoint for the query being made
         */
        deleteType(title, message, id, successCallback, path, errorMsg) {
            // Generate and display confirmation prompt
            this.confirmMessage(title, message).then(result => {
                console.log('result', result)
                if (result) {
                    this.$store
                        .dispatch(path, id)
                        .then(successCallback)
                        .catch(error => {
                            console.error(error)
                            this.doToast(
                                this.$translate('error'),
                                error.message || errorMsg,
                                'danger'
                            )
                        })
                }
            })
        },

        /**
         * Generalized helper function for deleting an item
         * @param {object} notificationFields
         * @param {string} notificationFields.type The type of item being deleted
         * @param {string} notificationFields.errorMsg
         * @param {object} model
         * @param {object} routes
         * @param {string} routes.baseRoute The route the user will be redirected to after the item is deleted
         * @param {string} routes.deleteRoute
         */
        async deleteItem(notificationFields, model, routes) {

            console.log("model...", model)
            // Destructure necessary objects
            const { type, errorMsg } = notificationFields
            let { baseRoute, deleteRoute } = routes
            //
            const checkAdmin = baseRoute.indexOf('/ams') == 0
            if (!checkAdmin) {
                baseRoute = '/ams' + baseRoute
            }

            // Generate and display confirmation prompt
            const title = `${this.$translate('delete')} ${type}?`
            const message = `${this.$translate('delete_note')} ${model.name}?`
            const result = await this.confirmMessage(title, message)
            console.log('result', result)
            if (result) {
                try {
                    this.generalDeleting = true
                    console.log('Attempt toast')
                    await this.$store.dispatch(deleteRoute, model.id)

                    this.doToast(
                        `${type} ${this.$translate('deleted')}!`,
                        `${type} ${this.$translate('delete_alert')}.`,
                        'success'
                    )
                    // Set delay since redirect happens too fast for toast to render
                    // Not all components follow the parent-child pattern so the toast could not be
                    // emitted to the parent to allow for the render after redirect
                    setTimeout(
                        () => this.$router.push({ path: baseRoute }),
                        1000
                    )
                } catch (error) {
                    console.error(error)
                    this.doToast(this.$translate('error'), error.message || errorMsg, 'danger')
                } finally {
                    this.generalDeleting = false
                }
            }
        },
    },
}
